// /ui-preview — THE OWNER'S SWITCH for the rebuilt console (lib/ui-v2.ts PREVIEWABLE). Shown to the owner alone (the
// same /api/me flag that lets him approve payout addresses); anyone else reads one line and nothing changes. On this
// device only: one localStorage key, then a reload, because the console decides its screens once, at start.
import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';
import { readState } from '../../lib/read-state';
import { PREVIEW_KEY, PREVIEW_OFFERED, PREVIEW_ON } from '../../lib/ui-v2';

function set(on: boolean) {
  try { if (on) localStorage.setItem(PREVIEW_KEY, '1'); else localStorage.removeItem(PREVIEW_KEY); } catch { /* private mode: nothing to keep */ }
  window.location.assign('/');
}

export function UiPreview() {
  const me = useQuery({ queryKey: ['me'], queryFn: () => api.me() });
  const state = readState(me);
  return (
    <section className="card mx-auto mt-6 max-w-md space-y-3">
      <h1 className="text-title font-semibold">New console</h1>
      {state === 'waiting' && <p className="text-body text-tg-hint">Reading…</p>}
      {state === 'failed' && <p className="text-body text-warn">Couldn&apos;t read your profile — try again.</p>}
      {state === 'known' && (!PREVIEW_OFFERED || !me.data?.canApprovePayouts) && (
        <p className="text-body text-tg-hint">Not available.</p>
      )}
      {state === 'known' && PREVIEW_OFFERED && me.data?.canApprovePayouts && (
        <>
          <p className="text-body text-tg-hint">This device only. Nobody else&apos;s console changes.</p>
          {PREVIEW_ON
            ? <button type="button" className="btn-secondary w-full" onClick={() => set(false)}>Back to today&apos;s console</button>
            : <button type="button" className="btn-primary w-full" onClick={() => set(true)}>Use the new console</button>}
        </>
      )}
    </section>
  );
}
